export const lungueges = {
    en: 'English',
    hi: 'Hindi',
    gj: 'Gujrati',
    kn: 'Kannada',
    te: "Telugu",
    tl: 'Tamil',
    ko: 'korean',
    sp: 'Spanish',
    ch: 'Chinese',
    ar: 'Arabic',
    bn: 'Bengali',
    ma: 'Malay',
    ml: 'Malayalam',
    mr: 'Marathi',
    rs: 'Russian',
    in: 'Indonesian'
}